import type { GraphpadWidgetConfig } from '@examdojo/math-widget/widgets/functions/graphpad';
import type { GeometryPadWidgetConfig } from '@examdojo/math-widget/widgets/geometrypad';
import { ContentBlockType, WidgetBlock } from '../../../model';

export type VisualEditorWidgetConfig = GraphpadWidgetConfig | GeometryPadWidgetConfig;

export const DEFAULT_GRAPHPAD_CONFIG = {
  id: 'default-graphpad',
  type: 'graphpad',
  params: {
    f: { type: 'linear', params: { m: 2, b: -2 } },
  },
  display: {
    coordinateSystem: {
      boundingbox: { xStart: -6, xEnd: 6, yStart: -6, yEnd: 6 },
      grid: { type: 'lines', visible: true },
    },
    elements: { f: {} },
  },
} satisfies GraphpadWidgetConfig;

export const DEFAULT_GEOMETRYPAD_CONFIG = {
  id: 'default-geometrypad',
  type: 'geometrypad',
  params: {
    elements: {
      t1: {
        type: 'Triangle',
        params: { a: 5, b: 7, gamma: 50 },
      },
    },
  },
  display: {
    geometry: {
      shape: { coloring: false },
      label: { coloring: true },
    },
  },
  behavior: {
    interactive: ['t1.point.A', 't1.point.B', 't1.point.C'],
  },
} satisfies GeometryPadWidgetConfig;

export const DEFAULT_WIDGET_PROPS: Omit<WidgetBlock, 'id'> = {
  type: ContentBlockType.Widget,
  widget_type: 'graphpad',
  config: DEFAULT_GRAPHPAD_CONFIG,
};
